import { useSelector } from 'src/store/react';
import {
  selectAuthenticated,
  selectFeatureFlag,
  selectCountry,
  selectSaveable,
} from 'src/store/selectors';

const useSideBar = () => {
  const authenticated = useSelector(selectAuthenticated);
  const saveable = useSelector(selectSaveable);
  const country = useSelector(selectCountry);
  const retireDisplayAds = useSelector(selectFeatureFlag('retireDisplayAds'));

  return {
    authenticated,
    saveable,
    country,
    retireDisplayAds,
  };
};

export default useSideBar;
